/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Main/Layout";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { get, put, post, patch } from "../../config/axios";
import { Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Searchbar from "../../components/Custom/SearchBar/Searchbar";
import DeleteModal from "../../components/Custom/DeleteModal/DeleteModal";
import { deleteAPI } from "../../helper/apiCallHelper";
import { doctorTableColumns } from "../../constants/userPage";
import { useDebouncedValue } from "../../helper/debounce";
import { toastMessage } from "../../utils/toastMessage";
import FormModal from "../../components/Custom/FormModal/FormModal";
import { DoctorFormFields } from "../../constants/userPage";
import { InPersonDoctorFields } from "../../constants/userPage";
import PatientModal from "../Patient/PatientModal";
import axios from "axios";
import AvailabilityModal from "./AvailabilityModal";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const debouncedSearch = useDebouncedValue(search, 500);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [specialities, setSpecialities] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [availabilityModalOpen, setAvailabilityModalOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const fetchUsers = async (searchValue) => {
    setLoading(true);
    await get(
      `/api/dashboard/dashUser/getAllAppUsers?page=${page}&limit=${10}&search=${searchValue}&userType=DOCTOR`
    )
      .then((res) => {
        setUsers(
          res?.data.map((item) => ({
            ...item,
            action: { edit: true, delete: true, manageAvailability: true },
          }))
        );
        setLoading(false);
        setPageCount(res?.totalPage);
        setTotalData(res?.totalData);
        setPerPage(res?.perPage);
        setCurrentPage(res?.currentPage);
      })
      .catch((err) => {
        console.log("err", err);
        setLoading(true);
      });
  };

  useEffect(() => {
    if (search === "") {
      fetchUsers("");
    } else if (debouncedSearch) {
      fetchUsers(debouncedSearch);
    }
  }, [search, debouncedSearch, message, page]);

  useEffect(() => {
    const fetchSpecialities = async () => {

      try {
        const response = await get("/api/dashboard/inPersonFeatures/get-speciality");
        setSpecialities(response?.data);
      } catch (error) {
        console.error("Failed to fetch specialties:", error);
      }
    };
    fetchSpecialities();
  }, []);

  const handleEdit = (row) => {
    // Implement the edit action for the selected row
    openModal("edit", row);
  };

  const handleDelete = (row) => {
    openModal("delete", row);
  };

  const handleDeleteUser = async (row) => {
    try {
      const deletedUser = await patch(
        `/api/dashboard/dashUser/deleteUser/${row._id}`
      );
      setMessage(deletedUser?.message);
      toastMessage(deletedUser?.message, "success");
    } catch (error) {
      console.log("error", error);
      setMessage("Something went wrong!");
      toastMessage("Something went wrong!", "error");
    }
    setDeleteModalOpen(false);
  };

  const handleStatus = (row) => {
    // Implement the status chnage for the selected row
    console.log("Delete clicked for row34:", row);
  };

  const handleActive = async (id, active) => {
    setLoading(true);
    let response = await put(
      `/api/dashboard/dashUser/updateAppAccount?id=${id}`,
      {
        active: active,
      }
    );
    setLoading(false);
    const username = response.data.fullname;
    const message = active
      ? `${username} has been successfully activated.`
      : `${username} has been successfully deactivated.`;

    setMessage(message);
    toastMessage(message, "success");
  };

  const handleSearch = (searchText) => {
    setSearch(searchText.trim());
    setPage(1);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleChange = (page) => {
    setPage(page);
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setEditData({}); // Reset editData to clear previous values
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setEditData(dataForEdit);
    } else if (type === "delete") {
      setDeleteModalOpen(true);
      setDeleteUser(dataForEdit);
    }
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleSubmit = async (formData, isEditing, id) => {
    setLoading(true);
    try {
      formData.optInPersonConsultant = formData?.optInPersonConsultant === "YES";
  
        // Convert empty string values to 0 for numeric fields
        const numericFields = ["experience", "consultationFee", "processingFee"];
        numericFields.forEach((field) => {
            if (formData[field] === "") {
                formData[field] = 0; // Replace empty string with null
            }
        });
      if (isEditing) {
        const { ...data } = formData;
        let response = await put(
          `/api/dashboard/dashUser/updateAppAccount?id=${id}`,
          data
        );
        if (!response || response.status === 400) {
          toastMessage(response.message.message, "error");
        } else {
          const username = response.data.fullname;
          const message = `${username} has been updated.`;
          setMessage(message);
          toastMessage(message, "success");
        }
      } else {
        formData = {
          ...formData,
          userType: "DOCTOR",
          password: "12345678",
          optInPersonConsultant: formData?.optInPersonConsultant, // Already converted to boolean on line 171
        };
        if (formData.experience) {
          formData.experience = Number(formData.experience) || undefined;
        }
        if (formData.consultationFee) {
          formData.consultationFee = Number(formData.consultationFee) || undefined;
        }
        if (formData.processingFee) {
          formData.processingFee = Number(formData.processingFee) || undefined;
        }
        const { ...data } = formData;
        console.log(data);
        const res = await post("/api/dashboard/dashUser/addAccount", data);

        if (!res || res.status === 400) {
          toastMessage(res.message.message, "error");

          setEditData({});

        } else {
          setMessage("Successfully added");
          toastMessage(res.data.message, "success");
          setEditData({});
          setIsModalOpen(false);
        }
      }
    } catch (err) {
      console.error("Error:", err);
      setMessage("Error while processing the request");
      toastMessage("Error while updating", "error");
    }
    setLoading(false);
  };
  const handleManageAvailability = (row) => {
    setSelectedDoctor(row);
    setAvailabilityModalOpen(true);
  };
  return (
    <>
      <Layout>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">Doctor's Detail</Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ width: "40%" }}>
              <Searchbar
                search={handleSearch}
                placeholder={"Search by full name or phone number "}
                debounceTime={1000}
              />
            </div>

            <Button
              onClick={() => openModal("add")}
              variant="outlined"
              startIcon={<AddIcon fontSize="large" />}
              style={{ fontWeight: "bold" }}
            >
              add doctor
            </Button>
          </div>
          <CustomTable
            data={users}
            columns={doctorTableColumns}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleStatus={handleStatus}
            handleActive={(row, active) => handleActive(row, active)}
            handlePageChange={(page) => handleChange(page)}
            pageNumber={page}
            pageCount={pageCount}
            totalData={totalData}
            perPage={perPage}
            currentPage={currentPage}
            loading={loading}
            handleManageAvailability={handleManageAvailability}
          />
          {search && users.length === 0 && !loading && (
            <Typography variant="body1" sx={{ color: 'red', textAlign: 'center', mt: 2 }}>
              No doctors found for your search.
            </Typography>
          )}
        </div>
      </Layout>
      <DeleteModal
        open={isDeleteModalOpen}
        onClose={handleCloseDeleteModal}
        onDelete={handleDeleteUser}
        data={deleteUser}
      />
      <AvailabilityModal
        open={availabilityModalOpen}
        onClose={() => setAvailabilityModalOpen(false)}
        doctor={selectedDoctor}
      />

      {/* common modal for patient and doctor */}
      <PatientModal
        isOpen={isModalOpen || editModal}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        fields={DoctorFormFields}
        header={editModal ? "Edit Doctor" : "Add Doctor"}
        initialData={editData}
        isEditing={editModal}
        specialities={specialities}
      />
    </>
  );
};

export default Users;
